import { formatDate, formatRelative, type StatusLevel } from '@westhetics/ui'
import type { TeamMember } from './api'

/**
 * O estado da pessoa da equipe por extenso. Quem ainda não entrou espera a própria pessoa, não quem
 * administra: nível `waiting`, como no usuário de clínica. E-mail de fora da empresa vence os
 * outros: a pessoa vai sair da equipe (RN-AUT-31), e a saída depende de a equipe pôr alguém com
 * e-mail da empresa: nível `attention`.
 */
export function teamStatus(member: Pick<TeamMember, 'status' | 'hasAllowedEmail'>): {
  level: StatusLevel
  label: string
} {
  if (!member.hasAllowedEmail) return { level: 'attention', label: 'E-mail fora da empresa' }
  return member.status === 'invited'
    ? { level: 'waiting', label: 'Aguardando primeiro acesso' }
    : { level: 'done', label: 'Ativo' }
}

/** O que acontece com quem tem e-mail de fora da empresa (RN-AUT-31), nas palavras da tela. */
export const OUTSIDE_EMAIL_EFFECT =
  'Só fica na equipe quem tem e-mail @westhetics.io, @westhetics.com.br ou @bytewell.com.br. Quando a primeira pessoa com e-mail da empresa entrar, quem está fora sai sozinho, com as sessões encerradas e a saída registrada na trilha.'

/** "há 2 dias" até 7 dias, a data depois disso; "ainda não entrou" sem acesso. */
export function lastSignInText(lastSignInAt: string | null) {
  if (!lastSignInAt) return 'ainda não entrou'
  return formatRelative(new Date(lastSignInAt))
}

/** Até quando o convite vale, ou desde quando venceu. */
export function inviteText(
  member: Pick<TeamMember, 'email' | 'inviteExpiresAt'>,
  now = new Date(),
) {
  if (!member.inviteExpiresAt) return null
  const expiresAt = new Date(member.inviteExpiresAt)
  return expiresAt.getTime() < now.getTime()
    ? `O convite enviado a ${member.email} venceu em ${formatDate(expiresAt)}.`
    : `O convite enviado a ${member.email} vale até ${formatDate(expiresAt)}.`
}

/** A âncora do cartão "Tirar da equipe" na ficha; "tirar da equipe" na lista leva até ele. */
export const REMOVE_ANCHOR = 'remove'
